var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


// WEBPACK FOOTER //
// ./packages/emdb/node_modules/core-js/library/modules/web.immediate.js